import React, { useContext } from "react";
import styles from "./Cover.module.scss";
import PathContext from "../../context/path";
const Cover = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.img}>
          <picture>
            <source media="(max-width: 767px)" srcSet={`${path}/img/main-mobile.webp`} />
            <img src={`${path}/img/main.webp`} alt="" />
          </picture>
        </div>
        <div className={styles.info}>
          <div className={styles.row}>
            <div className={styles.col}>
              <div className={styles.header}>
                <div className={styles.type}>HR</div>
                <div className={styles.time}>~ 5 минут</div>
              </div>
              <h1 className={styles.title}>5 аргументов, почему важно делать новогодний проект с итогами года</h1>
            </div>
            <div className={styles.col}>
              <div className={styles.author}>
                <div className={styles.author__text}>Автор</div>
                <div className={styles.author__name}>Николай Романов</div>
                <div className={styles.author__desc}>Руководитель отдела проектов</div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );

}

export default Cover;
